import { HYPERBEAT_TOKEN_ADDRESS, LHYPE_ADDRESS, STHYPE_ADDRESS, STHYPE_OVERSEER_ADDRESS } from '@hyperswap/addresses'

export const MAINTENANCE_IS_ACTIVATED = false
export const EARN_STHYPE_IS_DISABLED = !STHYPE_ADDRESS || !STHYPE_OVERSEER_ADDRESS
export const EARN_LHYPE_IS_DISABLED = !LHYPE_ADDRESS
export const EARN_HBHYPE_IS_DISABLED = !HYPERBEAT_TOKEN_ADDRESS
